<div class="d-flex-center m-t-20" *ngIf="!sale?.giftcard" @fadeInOut>
    <img src="assets/images/spinner1.gif" width="70">
</div>
<ng-container *ngIf="sale?.giftcard">
    <div class="p-10 p-b-0" @fadeInOut>
        <!-- Verification needed -->
        <ng-container *ngIf="requireVerification">
            <div class="text-center">
                <div class="d-flex-center m-t-20 m-b-10" style="background-color: #EEF5F9; border-radius: 8px;">
                    <img src="assets/images/QRblur.png" style="width: 306px;">
                </div>

                <div *ngIf="sale.customerCard.idImageURL != null || sale.customerCard.cardImageURL != null" class="font-bold">
                    Pronto vas a poder utilizar tu Givi, por seguridad necesitamos validar la autenticidad de la compra
                </div>

                <div *ngIf="sale.customerCard.idImageURL == null || sale.customerCard.cardImageURL == null" class="d-flex-center">
                    <button class="btn btn-primary" (click)="verifyCard()">Verificar Identidad</button>
                </div>
            </div>
        </ng-container>
        <!-- Verified -->
        <ng-container *ngIf="!requireVerification">
            <!-- Qr or Barcode -->
            <ng-container *ngIf="actionOption == 1 || actionOption == 2">
                <div *ngIf="!giviAwaitMinutes">
                    <div *ngIf="wantToRedeem" @fadeInOut id="targetDiv">
                        <!-- QR -->
                        <div class="d-flex-center" *ngIf="!showBarcode">
                            <qrcode [elementType]="'img'" [qrdata]="sale.qrCode + '/' + token" [margin]="-10" [width]="200"></qrcode>
                        </div>
                        <!-- Barcode -->
                        <div class="d-flex-center container-barcode m-b-10" *ngIf="showBarcode">
                            <svg id="barcode"></svg>
                        </div> 
        
                        <div class="d-flex-center">
                            <div class="font-14">Código: <b>{{sale.qrCode}}</b></div>
                            <div class="m-l-30">
                                <div class="font-14">Token: <b>{{token}}</b></div>
                                <ngb-progressbar type="primary" height="8px" [value]="currentTokenTimerValue" [max]="currentTokenTimerMax"></ngb-progressbar>
                            </div>
                        </div>
                    </div> 
                    <!-- Want to redeem? -->
                    <ng-container *ngIf="!wantToRedeem"> 
                        <div class="d-flex-center m-t-20" style="position: relative;" (click)="onChangeWantToRedeem()">
                            <img src="assets/images/qrblurgivis.png" width="160" style="opacity: 0.5;">
                            <div class="btn-dark-custom" style="position: absolute; top: 42%; width: 140px; padding: 8px 14px !important;">
                                <i class="mdi mdi-eye-outline font-18 mr-2"></i>Ver {{!showBarcode ? 'Qr' : 'Código'}}
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="giviAwaitMinutes" class="text-center">
                    <div class="d-flex-center m-t-20 m-b-20">
                        <img src="assets/images/background/GiviNotAvailable.png" style="width: 306px;">
                    </div>
    
                    <div class="font-bold">Este Givi estará disponible pronto</div>
                    <div *ngIf="giviAwaitMinutes" class="font-c2">
                        Lo vas a poder canjear hasta dentro de
                        <span class="font-c2 font-bold m-l-5">
                            <span *ngIf="giviAwaitHours">
                                {{giviAwaitHours}} Horas
                            </span>
                            <span *ngIf="giviAwaitMinutes < 60">
                                {{giviAwaitMinutes}} Minutos
                            </span>
                        </span>
                    </div>
                </div>
            </ng-container> 
            <!-- Send -->
            <ng-container *ngIf="actionOption == 3">
                <app-send-givi [sale]="sale"></app-send-givi>
            </ng-container>
            <!-- Options -->
            <div class="d-flex-center m-t-20">
                <div class="text-center" (click)="onChangeOption(1)" [ngClass]="actionOption == 1 ? 'btn-action-active' : 'btn-action'">
                    <i class="mdi mdi-qrcode" style="font-size: 24px;"></i>
                    <div class="font-12" style="margin-top: -8px;">QR</div>
                </div>
                <div class="text-center m-l-10" (click)="onChangeOption(2)" [ngClass]="actionOption == 2 ? 'btn-action-active' : 'btn-action'">
                    <i class="mdi mdi-barcode" style="font-size: 24px;"></i>
                    <div class="font-12" style="margin-top: -8px;">Barras</div>
                </div>
                <div class="text-center m-l-10" (click)="onChangeOption(3)" [ngClass]="actionOption == 3 ? 'btn-action-active' : 'btn-action'">
                    <i class="mdi mdi-gift-outline" style="font-size: 24px;"></i>
                    <div class="font-12" style="margin-top: -8px;">Regalar</div>
                </div>
                <div *ngIf="false" class="text-center m-l-10" (click)="onChangeOption(4)" [ngClass]="actionOption == 4 ? 'btn-action-active' : 'btn-action'">
                    <i class="mdi mdi-download-outline" style="font-size: 24px;"></i>
                    <div class="font-12" style="margin-top: -8px; margin-left: -2px;">Descargar</div>
                </div>
            </div>

            <!-- Details -->
            <ng-container *ngIf="!showMoreDetails">
                <div class="d-flex-center text-muted m-t-20" (click)="showMoreDetails = true">
                    <div class="font-14">Más detalles</div>
                    <i class="mdi mdi-arrow-down font'18"></i>
                </div> 
            </ng-container>
            <div *ngIf="showMoreDetails" @fadeInOut>
                <div class="d-flex-center text-muted m-t-20" (click)="showMoreDetails = false">
                    <div class="font-14">Menos detalles</div>
                    <i class="mdi mdi-arrow-up font'18"></i>
                </div>
                <!-- Cliente -->
                <div class="border-top p-t-10 m-t-10">
                    <div class="d-flex-between">
                        <div class="font-14 font-bold">Regalo para: </div>
                        <div (click)="showGiviNote(sale.transactionNotes, sale.id, sale.customerOwnerId,sale.isExpired)">
                            <div class="mr-auto tag" *ngIf="sale.transactionNotes == null">Agregar Nota</div>
                            <div class="mr-auto tag" *ngIf="sale.transactionNotes != null"
                                [ngStyle]="{'background-color':sale.transactionNotes.color, 'color':'#ffffff'}">
                                {{sale.transactionNotes.note.length > 12? sale.transactionNotes.note.slice(0,9) + '...': sale.transactionNotes.note}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Vence -->
                <div class="border-top p-t-10 m-t-10">
                    <div class="d-flex-between">
                        <div class="font-14 font-bold">Vencimiento: </div>
                        <div class="font-14">{{sale.expirationAt | date: 'dd MMMM yyyy'}}</div>
                    </div>
                </div>
                <!-- Description -->
                <div class="border-top p-t-10 m-t-10">
                    <div class="d-flex-between font-14">
                        <div class="font-bold">Descripción: </div>
                        <div>
                            <small *ngIf="!showDescription" class="font-12 m-t-8 font-bold" (click)="showDescription = true" style="text-decoration: underline;">Ver</small>
                            <small *ngIf="showDescription" class="font-12 m-t-8 font-bold" (click)="showDescription = false" style="text-decoration: underline;">Ocultar</small>
                        </div> 
                    </div>
                    <div class="mr-auto text-left" *ngIf="showDescription">
                        <p class="font-12 ml-2" [innerHTML]="sale.productDescription"></p>
                    </div>
                </div>

                <div class="border-top p-t-10 m-t-10" *ngIf="!giviAwaitMinutes">
                    <!-- Store Names -->
                    <div *ngIf="!sale?.communityId">
                        <app-smart-list-store [stores]="vendorStores"></app-smart-list-store>
                    </div>
                    <!-- Community suppliers -->
                    <div *ngIf="sale?.communityId">
                        <app-smart-list-community-vendor [vendors]="sale?.giftcard.vendors"></app-smart-list-community-vendor>
                    </div>
                </div>

                <div class="text-center"> 
                    <app-delete-transaction [transaction]="sale"></app-delete-transaction>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>


<app-givi-note-modal [giviNote]="giviNote" [transactionId]="transactionId" [customerOwnerId]="customerOwnerId" [countryNote]="country"
(onUpdateNote)="onUpdateNote($event)"></app-givi-note-modal>

<!-- Success Redeemed -->
<ng-container *ngIf="showSuccess">
    <app-redeemed-success (closeSuccess)="onCloseSuccess()"></app-redeemed-success>
</ng-container>


<!-- VerifyCard -->
<app-verify-card [issueTypes]="issueTypes"></app-verify-card>